(() => {
  const THEME_KEY = 'mkphone-theme-mode';
  const COOKIE_KEY = 'mkphone-cookie-consent';
  const COOKIE_LATER_KEY = 'mkphone-cookie-consent-later';
  const INTRO_KEY = 'mkphone-intro-seen-v1';
  const INTRO_EVENT = 'mkphone-intro-done';
  const root = document.documentElement;

  function hasSeenIntro() {
    try {
      return sessionStorage.getItem(INTRO_KEY) === '1';
    } catch (error) {
      return root.classList.contains('mk-intro-seen');
    }
  }

  function waitForIntro(callback) {
    const overlay = document.querySelector('[data-lockscreen-overlay]');
    if (!overlay || hasSeenIntro()) {
      callback();
      return;
    }

    const onDone = () => {
      window.removeEventListener(INTRO_EVENT, onDone);
      callback();
    };

    window.addEventListener(INTRO_EVENT, onDone, { once: true });
  }

  function setTheme(mode) {
    root.setAttribute('data-theme-mode', mode);
    if (document.body) {
      document.body.setAttribute('data-theme-mode', mode);
    }

    const toggle = document.querySelector('[data-theme-toggle]');
    const label = document.querySelector('[data-theme-label]');
    if (toggle) {
      const isDark = mode === 'dark';
      toggle.setAttribute('aria-pressed', String(isDark));
      toggle.setAttribute('title', isDark
        ? (window.mkphoneI18n && window.mkphoneI18n.activateLight || 'Activer le mode clair')
        : (window.mkphoneI18n && window.mkphoneI18n.activateDark || 'Activer le mode sombre'));
    }
    if (label) {
      label.textContent = mode === 'dark'
        ? (window.mkphoneI18n && window.mkphoneI18n.lightMode || 'Mode clair')
        : (window.mkphoneI18n && window.mkphoneI18n.darkMode || 'Mode sombre');
    }
  }

  function saveTheme(mode) {
    try {
      localStorage.setItem(THEME_KEY, mode);
    } catch (error) {
      void error; // Storage unavailable
    }
  }

  function applyStoredTheme() {
    let storedTheme = 'light';
    try {
      storedTheme = localStorage.getItem(THEME_KEY) || root.getAttribute('data-theme-mode') || 'light';
    } catch (error) {
      storedTheme = root.getAttribute('data-theme-mode') || 'light';
    }
    setTheme(storedTheme);
  }

  function syncShopifyConsent(choice) {
    if (choice === 'later') return;

    const customerPrivacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!customerPrivacy || typeof customerPrivacy.setTrackingConsent !== 'function') return;

    const allowTracking = choice === 'accept';

    try {
      customerPrivacy.setTrackingConsent(
        {
          analytics: allowTracking,
          marketing: allowTracking,
          preferences: true,
          sale_of_data: false,
        },
        () => {}
      );
    } catch (error) {
      void error; // Consent API unavailable
    }
  }

  function hideCookieBanner() {
    const banner = document.querySelector('[data-cookie-banner]');
    if (!banner) return;
    banner.classList.remove('is-visible');
    banner.setAttribute('aria-hidden', 'true');
    setTimeout(() => {
      banner.hidden = true;
    }, 250);
  }

  function getStoredCookieChoice() {
    let storedChoice = null;

    try {
      storedChoice = localStorage.getItem(COOKIE_KEY);
      if (storedChoice === 'later') {
        localStorage.removeItem(COOKIE_KEY);
        storedChoice = null;
      }
    } catch (error) {
      storedChoice = null;
    }

    return storedChoice;
  }

  function isCookieBannerDeferredForSession() {
    try {
      return sessionStorage.getItem(COOKIE_LATER_KEY) === '1';
    } catch (error) {
      return false;
    }
  }

  function handleCookieChoice(choice) {
    if (choice === 'later') {
      try {
        sessionStorage.setItem(COOKIE_LATER_KEY, '1');
      } catch (error) {
        void error; // Storage unavailable
      }
      hideCookieBanner();
      return;
    }

    try {
      localStorage.setItem(COOKIE_KEY, choice);
      sessionStorage.removeItem(COOKIE_LATER_KEY);
    } catch (error) {
      void error; // Storage unavailable
    }

    syncShopifyConsent(choice);
    hideCookieBanner();
  }

  function initCookieBanner() {
    const banner = document.querySelector('[data-cookie-banner]');
    if (!banner) return;

    const storedChoice = getStoredCookieChoice();

    if (storedChoice) {
      syncShopifyConsent(storedChoice);
    } else if (!isCookieBannerDeferredForSession()) {
      waitForIntro(() => {
        setTimeout(() => {
          banner.hidden = false;
          banner.setAttribute('aria-hidden', 'false');
          requestAnimationFrame(() => banner.classList.add('is-visible'));
        }, 700);
      });
    }

    banner.querySelectorAll('[data-cookie-action]').forEach((button) => {
      button.addEventListener('click', () => {
        handleCookieChoice(button.getAttribute('data-cookie-action'));
      });
    });
  }

  function initReviewMarquees(scope = document) {
    const marquees = scope.querySelectorAll('[data-review-marquee]');
    if (!marquees.length) return;

    marquees.forEach((marquee) => {
      if (typeof marquee._mkDestroyMarquee === 'function') {
        marquee._mkDestroyMarquee();
      }

      const track = marquee.querySelector('.mk-live-reviews__marquee-track');
      if (!track) return;

      marquee.classList.remove('is-enhanced');
      track.style.transform = '';
      marquee.style.setProperty(
        '--mk-review-marquee-duration',
        `${Math.max(parseFloat(marquee.getAttribute('data-marquee-speed')) || 34, 8)}s`
      );

      marquee._mkDestroyMarquee = () => {
        marquee.classList.remove('is-enhanced');
        track.style.transform = '';
      };
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    applyStoredTheme();

    const toggle = document.querySelector('[data-theme-toggle]');
    if (toggle) {
      toggle.addEventListener('click', () => {
        const nextTheme = root.getAttribute('data-theme-mode') === 'dark' ? 'light' : 'dark';
        saveTheme(nextTheme);
        setTheme(nextTheme);
      });
    }

    initCookieBanner();
    initReviewMarquees();
  });

  window.addEventListener('load', () => {
    initReviewMarquees();
  });

  document.addEventListener('shopify:section:load', (event) => {
    initReviewMarquees(event.target);
  });
})();
